export const platformVersion = '^13.2.0';
